<template>
  <div class="dropdown-menu-search-button-wrap">
    <p class="title">
      {{ $t(title) }}<span v-if="required">*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      :rules="rules"
      class="dropdown-wrap"
    >
      <input
        type="hidden"
        :value="value"
      >
      <div
        v-click-outside="$_dropdownClose"
        class="dropdown-menu-search-button"
        :class="{outline: outline, widthFix180: widthFix180,widthFix200:widthFix200,disabled:disabled,error:errors.length>0}"
      >
        <i
          v-if="leadingIcon"
          class="icon leading-icon"
          :class="leadingIcon"
        />
        <button
          :class="{selected:value}"
          @click="$_onclick()"
        >
          {{ _computedButtonTextLabel }}
        </button>
        <i
          v-if="outline"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{show: dropdown_menu_show}"
        />
        <i
          v-if="disabled"
          class="icon trailing-icon icon-chevron-down"
        />
        <i
          v-else-if="!outline && !dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <div
          class="dropdown-menu"
          :class="{show: dropdown_menu_show}"
        >
          <div class="search-tool">
            <SearchInput
              v-model="searchInputButton.value"
              :placeholder="searchInputButton.placeholder"
              :text-label="searchInputButton.textLabel"
              @enter="$_searchMenuByTextLabel()"
            />
          </div>
          <perfect-scrollbar class="ps dropdown-scrollable-content">
            <div
              v-for="(item,item_k) in _dropdownItems"
              :key="item_k"
              class="dropdown-menu-item"
              :class="{selected:$_selectedItem(item)}"
              @click="selectMenuItem(item)"
            >
              {{ item.textLabel }}
            </div>
          </perfect-scrollbar>
        </div>
      </div>
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "DropdownMenuSearchButton",
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    dropdownMenuItem: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: [Number, String],
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    widthFix180: {
      type: Boolean,
      default: false,
    },
    widthFix200: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dropdown_menu_show: false,
      searchInputButton: {
        value: "",
        placeholder: this.$t("搜尋"),
        textLabel: this.$t("搜尋"),
      },
    };
  },
  computed: {
    _computedButtonTextLabel() {
      let selectedItem = this.value;
      let num = this.$_selectedItemNum(selectedItem);
      if (num > -1) {
        let selectedItemTextLabel = this.dropdownMenuItem[num];
        return selectedItemTextLabel.textLabel;
      }
      let placeholder = this.placeholder;
      if (placeholder) return this.$t(placeholder);
      return this.dropdownMenuItem[0].textLabel;
    },
    _dropdownItems() {
      return this.$_searchMenuByTextLabel();
    },
  },
  methods: {
    $_onclick() {
      if (this.disabled) {
        return;
      }
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdown_menu_show = !this.dropdown_menu_show;
    },
    selectMenuItem(item) {
      // this.$emit("click", item.id);
      // this.placeholder = item.textLabel;
      this.$emit("input", item.id);
      // this.value = item.id;
      this.dropdown_menu_show = false;
    },
    $_selectedItem(item) {
      if (this.value == item.id) {
        return true;
      } else {
        return false;
      }
    },
    $_dropdownClose() {
      this.dropdown_menu_show = false;
      this.searchInputButton.value = "";
    },
    $_selectedItemNum(select) {
      if (!this.dropdownMenuItem) return;
      if (!select) {
        return;
      }
      let allId = this.dropdownMenuItem.map((item) => {
        return item.id;
      });
      let selectedNum = allId.indexOf(select);
      return selectedNum;
    },
    $_searchMenuByTextLabel() {
      let originalItems = [...this.dropdownMenuItem];
      if (this.searchInputButton.value) {
        let searchOrigianlItems = originalItems.filter(
          (item) =>
            item.textLabel
              .toLowerCase()
              .includes(this.searchInputButton.value.toLowerCase()) > -1
        );
        return searchOrigianlItems;
      }
      return originalItems;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/dropdown-menu-search-button";
</style>